import { selectors, useAppSelector } from 'state/global-state';

export const useAppliedOffers = () => useAppSelector(selectors.loyalty.selectAppliedOffers);
